import {useMemo} from 'react';
import useWindowSize from "./useWindowSize";
import {removeFirstAndLastChar} from '../helpers/index';
import vars from '../utils/vars';

const mediaQuerySmall = removeFirstAndLastChar(vars['mq-device-small']);
const mediaQueryBig = removeFirstAndLastChar(vars['mq-device-big']);

export default function useDeviceSizeDetect(props = {}) {
	const { delay = 50 } = props;
	const size = useWindowSize(delay);

	const isMobile = useMemo(() => {
		return window.matchMedia(mediaQuerySmall).matches
	}, [size]);

	const isDesktop = useMemo(() => {
		return window.matchMedia(mediaQueryBig).matches
	}, [size]);

	return {
		isMobile,
		isDesktop,
	}
}